import { Input, Space, Text } from '@billy/design-system'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useTrackInvoicingSettings } from '@features/invoicingSettings/hooks/useTrackInvoicingSettings'
import { InvoiceLogo, type UploadZervantInvoiceLogoResponse } from '@features/invoicingSettings/modules/logoAndBranding'

import { useDirtyRoute } from '../../../../../../../../../../../../contexts/dirtyRouteContext'
import { useFormContext, useWatch } from '../../../../../../../../../../../../hooks'
import { usePredefinedInvoiceSettingsFormValues } from '../../../../../../hooks/usePredefinedInvoiceSettingsFormValues'
import { InvoiceSettingsFormSchema } from '../../../../../../types/invoiceSettingsFormSchema'

export const DefaultInvoiceLogo = () => {
  const { t } = useTranslation()
  const { trackInvoicingSettings } = useTrackInvoicingSettings()
  const { setValue, control } = useFormContext<InvoiceSettingsFormSchema>()
  const { isLoading } = usePredefinedInvoiceSettingsFormValues()
  const { setDirty } = useDirtyRoute()

  const logoUrl = useWatch({ control, name: 'logoUrl' })

  const handleInvoiceLogoUploadSuccess = useCallback(
    (data: UploadZervantInvoiceLogoResponse) => {
      trackInvoicingSettings('Logo uploaded')
      setValue('logoUrl', data.url)
      setValue('logoId', String(data.logoId))
      setDirty(true)
    },
    [setDirty, setValue, trackInvoicingSettings],
  )

  const handleInvoiceLogoDeleteSuccess = useCallback(() => {
    setValue('logoUrl', null)
    setValue('logoId', null)
    setDirty(true)
  }, [setDirty, setValue])

  return (
    <>
      <Text colorVariant="secondary">{t('settings.organization.external_invoice.appearance.logo.label')}</Text>
      <Space size="s6" />
      <InvoiceLogo
        onDeleteSuccess={handleInvoiceLogoDeleteSuccess}
        onUploadSuccess={handleInvoiceLogoUploadSuccess}
        logoUrl={logoUrl}
        isLoading={isLoading}
      />
      <Input name="logoId" hidden />
      <Input name="logoUrl" hidden />
    </>
  )
}
